import styled from '@emotion/styled';
import { responsiveFontSize } from '@presentation/styles';
import { SectionTitle } from '../Section';

export const ModalSectionTitle = styled(SectionTitle)`
  ${responsiveFontSize(32, 4)}
`;
